// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/login-image.jfif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/my-profile-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* login */
.login-hero {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
.login-hero .title-line {
  background-color: rgba(0, 0, 0, 0.75);
  color: #fff;
  padding: 20%;
  height: 70vh;
  width: 100%;
}
.login-hero .title-line .logo {
  font-size: 28px;
  font-weight: 600;
  text-align: left;
  margin-bottom: 30%;
}
.login-hero .title-line p {
  font-size: 28px;
  font-weight: 600;
}
.login-hero .title-line p .pink {
  color: #ff55a7;
}
.login-hero .title-line p .yellow {
  color: #ffc960;
}
.login-hero .title-line p .cyan {
  color: #27d4ab;
}
.login-form {
  padding: 0% 15%;
  font-size: 14px;
  font-family: "Poppins", sans-serif;
}
.login-form input {
  font-size: 14px;
}
.login-form h1 {
  font-size: 24px;
}
.login-form a {
  color: #000;
  font-size: 12px;
}
.login-form a:hover {
  color: #0c3b83;
}
.login-form .login-btn {
  font-size: 16px;
  background: #000639;
  padding: 10px 0px;
  font-family: "Poppins", sans-serif !important;
}
.login-form .login-btn:hover {
  font-size: 16px;
  background: #000426;
}
.copy-right {
  font-size: 12px;
  color: #757575;
  position: absolute;
  bottom: 10px;
  text-align: center;
}
.login-social .select-upload .bi::before,
[class*=" bi-"]::before,
[class^="bi-"]::before {
  font-size: 15px;
}
/* sing-form */
.sing-form a {
  text-decoration: none;
  color: #000;
  font-size: 16px;
}
.sing-form .icon {
  width: 26px;
  height: 26px;
}
/* copy */
.copy-right {
  font-size: 12px;
  color: #757575;
  position: absolute;
  bottom: 10px;
  text-align: center;
}
/* photo upload */
.org-events-photo-upload h5 {
  font-size: 16px;
}
.org-events-photo-upload .file-area {
  width: 100%;
  position: relative;
  color: #cacdd5;

  input[type="file"] {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0;
    cursor: pointer;
  }
  .org-upload-event-photo {
    width: 100%;
    padding: 20%;
    background: #f4f6f8;
    border: 1px dashed #cacdd5;
    text-align: center;
    transition: background 0.3s ease-in-out;
    font-size: 12px;
    .success {
      display: none;
    }
  }
  &:hover .org-upload-event-photo {
    background: rgba(255, 255, 255, 0.1);
  }
  input[type="file"]:focus + .org-upload-event-photo {
    outline: none;
    outline: none;
  }
  input[type="file"]:valid + .org-upload-event-photo {
    padding: 2px;
    .success {
      display: inline-block;
    }
    .default {
      display: none;
    }
  }
}
.org-events-photo-upload .file-area .message {
  color: #000;
}
.org-events-photo-upload
  .modal-dialog
  .modal-content
  .modal-footer
  .btn-upload {
  background: #000639;
  color: #fff;
}
.org-events-photo-upload
  .modal-dialog
  .modal-content
  .modal-footer
  .btn-upload:hover {
  color: #fff;
  background: #27d4ab;
}
.org-events-photo-upload
  .modal-dialog
  .modal-content
  .modal-footer
  .btn-cancel {
  color: #000639;
  border: 1px solid #000639;
  background: #fff;
}
.org-events-photo-upload
  .modal-dialog
  .modal-content
  .modal-footer
  .btn-cancel:hover {
  background: #000639;
  color: #fff;
}
.ticket-detail h1 {
  color: #454f5b;
  font-size: 18px;
  font-weight: 600;
}
.ticket-detail p {
  color: #454f5b;
  font-size: 14px;
  font-weight: 400;
}
.ticket-detail a {
  color: #454f5b;
  font-size: 14px;
  font-weight: 400;
}
.readmore {
  color: #454f5b;
  font-size: 14px !important;
  font-weight: 400;
}
/* ticket color yellow*/
.ticket-box-yellow {
  background: rgba(253, 230, 183, 0.8);
  border: 2px dashed #ffc960;
  padding: 20px 50px;
  position: relative;
  width: 100%;
  height: 150px;
}
.ticket-box-yellow::before,
.ticket-box-yellow::after {
  content: "";
  position: absolute;
  top: 0;
  height: 30px;
  width: 60px;
  /* z-index: 1; */
}
.ticket-box-yellow::before {
  border-radius: 150px 150px 0 0;
  background: #fff;
  border-right: 2px dashed #ffc960;
  border-left: 2px dashed #ffc960;
  border-top: 2px dashed #ffc960;
  left: -17px;
  top: 40%;
  rotate: 90deg;
}
.ticket-box-yellow::after {
  border-radius: 150px 150px 0 0;
  background: #fff;
  border-right: 2px dashed #ffc960;
  border-left: 2px dashed #ffc960;
  border-top: 2px dashed #ffc960;
  right: -17px;
  top: 40%;
  rotate: -90deg;
}
.ticket-info-yellow {
  background: #fff;
  border-right: 2px dashed #ffc960;
  border-left: 2px dashed #ffc960;
  border-bottom: 2px dashed #ffc960;
}
/* ticket color green*/
.ticket-box-green {
  background: #bef2e6;
  border: 2px dashed #27d4ab;
  padding: 20px 50px;
  position: relative;
  width: 100%;
  height: 150px;
}
.ticket-box-green::before,
.ticket-box-green::after {
  content: "";
  position: absolute;
  top: 0;
  height: 30px;
  width: 60px;
  /* z-index: 1; */
}
.ticket-box-green::before {
  border-radius: 150px 150px 0 0;
  background: #fff;
  border-right: 2px dashed #27d4ab;
  border-left: 2px dashed #27d4ab;
  border-top: 2px dashed #27d4ab;
  left: -17px;
  top: 40%;
  rotate: 90deg;
}
.ticket-box-green::after {
  border-radius: 150px 150px 0 0;
  background: #fff;
  border-right: 2px dashed #27d4ab;
  border-left: 2px dashed #27d4ab;
  border-top: 2px dashed #27d4ab;
  right: -17px;
  top: 40%;
  rotate: -90deg;
}
.ticket-info-green {
  background: #fff;
  border-right: 2px dashed #27d4ab;
  border-left: 2px dashed #27d4ab;
  border-bottom: 2px dashed #27d4ab;
}
/* View Breakup */
.view-Breakup-box {
  background: #454f5b;
  padding: 5px;
  font-size: 12px;
  position: relative;
}
.view-Breakup-box-arrow {
  position: absolute;
  top: -10px;
  right: 10px;
  color: #454f5b;
}
.view-Breakup-box .dropdown-item {
  color: #fff;
}
.view-Breakup-box .dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid #637381;
  opacity: 1;
}
.view-Breakup-box .dropdown-item:focus,
.dropdown-item:hover {
  color: none;
  background: none;
}
.org-events-photo-upload a {
  font-size: 12px;
}
.org-events-photo-upload .form-select {
  font-size: 14px;
}
.view-Breakup-box h1 {
  font-size: 14px;
  color: #fff;
}
/* Participant Form */
.participant-form .card {
  font-size: 14px;
}
.participant-form .accordion .accordion-item .accordion-header h1 {
  font-size: 16px;
  font-weight: 500;
}
.participant-form
  .modal
  .modal-dialog
  .modal-content
  .modal-header
  .modal-title,
.participant-form .modal .modal-dialog .modal-content .modal-body h1,
label {
  font-size: 14px !important;
}
.skip {
  color: #637381;
  font-size: 14px !important;
}
/* Discount Coupons */
.org-events-photo-upload .discount-Coupons .offer {
  padding: 10px;
  width: 100%;
}
.org-events-photo-upload .discount-Coupons .offer h1 {
  font-size: 32px;
  font-weight: 700;
}
.org-events-photo-upload .discount-Coupons .offer h1 span {
  font-size: 20px;
  font-weight: 400;
}
.org-events-photo-upload .discount-Coupons {
  border: #eba416 dashed 2px;
  border-radius: 8px;
  background: #ffc960;
  margin: 0 20%;
}
.org-events-photo-upload .discount-Coupons .name {
  background: rgba(255, 255, 255, 0.5);
  padding: 10px 30px;
  align-items: center;
  display: flex;
  border-right: #000 dashed 2px;
}
.org-events-photo-upload .discount-Coupons .name .dis {
  color: #ffbd3d;
  font-size: 24px;
  font-weight: 700;
  writing-mode: vertical-rl;
  position: absolute;
  transform: rotate(-180deg);
}
.org-events-photo-upload .discount-Coupons .name .cou {
  color: #fff;
  font-size: 40px;
  font-weight: 700;
  writing-mode: vertical-rl;
  margin-left: 30px;
  transform: rotate(-180deg);
}
.org-events-photo-upload .discount-Coupons .discount-Name {
  font-size: 18px;
  font-weight: 600;
}
.org-events-photo-upload .discount-Coupons .date-time {
  font-size: 14px;
}
.org-events-photo-upload .discount-Coupons .no {
  font-size: 18px;
  font-weight: 500;
}
.org-events-photo-upload .discount-Coupons a {
  font-size: 14px;
  color: #000;
}
.discount-Coupons-box {
  position: relative;
}
/* coupan color */
.org-events-photo-upload .discount-Coupons-green {
  border: #059170 dashed 2px;
  background: #27d4ab;
}
.org-events-photo-upload .discount-Coupons-green .name {
  background: rgba(255, 255, 255, 0.5);
}
.org-events-photo-upload .discount-Coupons .name .dis-green {
  color: #08b38b;
}
/* Event Setting */
.event-setting .info-gst {
  font-size: 14px;
}
/* User Profile */
.user-profile .nav-underline {
  --bs-nav-underline-gap: 10rem;
  --bs-nav-underline-border-width: 0.125rem;
  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);
  gap: var(--bs-nav-underline-gap);
  border-bottom: #cacdd5 solid 1px !important;
}
.user-profile .nav-underline .nav-item {
  font-size: 14px;
}
.user-profile .icon {
  padding: 6px 9px;
  background: #86ffe2;
  border-radius: 50%;
}
.user-profile .nav-link.active,
.user-profile .nav-link:hover {
  font-weight: 500;
  color: var(--Primary-Color-brand-5C6ACA);
  border-bottom-color: currentcolor;
  stroke: var(--Primary-Color-brand-5C6ACA);
}
.user-profile .nav-link {
  color: var(--gray-darklight);
  stroke: var(--gray-darklight);
}
.user-profile,
.user-profile .bashboard-table th,
.user-profile .btn,
.user-profile .bashboard-table td {
  font-size: 12px;
}
.user-profile h1 {
  font-size: 16px;
}
.user-profile .tab-content .table-responsive .table tbody .text-success-btn {
  color: var(--success);
}
/* .user-profile svg {
  width: 25px;
  height: 25px;
  stroke: var(--gray-darklight);
}
.user-profile svg:hover {
  fill: red;
  stroke: var(--Primary-Color-brand-5C6ACA);;
} */
.user-profile .send-notification-box {
  background: #f4f6f8;
  border: #dfe4e8 1px solid;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 44px;
}

.user-profile .send-notification-box img {
  width: 25px;
  height: 25px;
}

.user-profile .form-switch.form-check-reverse .form-check-input {
  width: 4em;
  height: 2em;
}
.user-profile .form-switch-text {
  font-size: 14px;
}
.user-profile .my-profile-pic {
  background: #5c6aca;
  padding: 10px;
  font-size: 25px;
  font-weight: 600;
  color: #fff;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  margin: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.user-profile input {
  font-size: 14px;
}
.user-profile .btn {
  font-size: 14px;
}
.user-profile .images {
  width: 120px !important;
}
/*  */
.organizer-logo,
.organizer-logo select {
  font-size: 14px;
}
.organizer-logo .file-area {
  width: 100%;
  position: relative;
  color: #cacdd5;

  input[type="file"] {
    position: absolute;
    width: 200px;
    height: 200px;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0;
    cursor: pointer;
  }
  .organizer-logo-photo {
    width: 200px;
    height: 200px;
    background: #f4f6f8;
    border: 1px solid #cacdd5;
    text-align: center;
    border-radius: 8px;
    transition: background 0.3s ease-in-out;
    font-size: 12px;
    .success {
      display: none;
    }
  }
  &:hover .organizer-logo-photo {
    background: rgba(255, 255, 255, 0.1);
  }
  input[type="file"]:focus + .organizer-logo-photo {
    outline: none;
    outline: none;
  }
  input[type="file"]:valid + .organizer-logo-photo {
    padding: 2px;
    .success {
      display: inline-block;
    }
    .default {
      display: none;
    }
  }
}
.organizer-success h1 {
  font-size: 24px;
  font-weight: 600;
}
.organizer-success-logo {
  width: 10%;
  text-align: center;
}
.my-profile-banner {
  position: relative;
  background: #f9fafb;
  padding: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
}
.my-profile-banner h1 {
  font-size: 20px;
  font-weight: 600;
}
.my-profile-banner p {
  font-size: 14px;
  font-weight: 500;
  color: #637381;
}
.my-profile-banner .details {
  font-size: 18px;
  font-weight: 500;
  color: #212b35;
}
.my-profile-banner .details span {
  font-size: 20px;
  font-weight: 600;
  color: #27d4ab;
}
.my-profile-banner-accordion .accordion-button:not(.collapsed) {
  color: none !important;
  background-color: #ffffff;
  box-shadow: none !important;
}
@media (max-width: 575.98px) {
  .user-profile .btn {
    font-size: 10px;
  }
  .user-profile .container {
    display: none;
  }
}

@media (max-width: 767.98px) {
  .user-profile .btn {
    font-size: 10px;
  }
  .user-profile .container {
    display: none;
  }
}
@media (max-width: 991.98px) {
  .user-profile .btn {
    font-size: 10px;
  }
  .user-profile .container {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/login.css"],"names":[],"mappings":"AAAA,UAAU;AACV;EACE,yDAAiD;EACjD,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,qCAAqC;EACrC,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,eAAe;EACf,kCAAkC;AACpC;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,6CAA6C;AAC/C;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;AACA;;;EAGE,eAAe;AACjB;AACA,cAAc;AACd;EACE,qBAAqB;EACrB,WAAW;EACX,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA,SAAS;AACT;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;AACA,iBAAiB;AACjB;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;;EAEd;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,UAAU;IACV,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,0BAA0B;IAC1B,kBAAkB;IAClB,uCAAuC;IACvC,eAAe;IACf;MACE,aAAa;IACf;EACF;EACA;IACE,oCAAoC;EACtC;EACA;IACE,aAAa;IACb,aAAa;EACf;EACA;IACE,YAAY;IACZ;MACE,qBAAqB;IACvB;IACA;MACE,aAAa;IACf;EACF;AACF;AACA;EACE,WAAW;AACb;AACA;;;;;EAKE,mBAAmB;EACnB,WAAW;AACb;AACA;;;;;EAKE,WAAW;EACX,mBAAmB;AACrB;AACA;;;;;EAKE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;AACA;;;;;EAKE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;AAClB;AACA,uBAAuB;AACvB;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,gCAAgC;EAChC,+BAA+B;EAC/B,8BAA8B;EAC9B,WAAW;EACX,QAAQ;EACR,aAAa;AACf;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,gCAAgC;EAChC,+BAA+B;EAC/B,8BAA8B;EAC9B,YAAY;EACZ,QAAQ;EACR,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,+BAA+B;EAC/B,iCAAiC;AACnC;AACA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,gCAAgC;EAChC,+BAA+B;EAC/B,8BAA8B;EAC9B,WAAW;EACX,QAAQ;EACR,aAAa;AACf;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,gCAAgC;EAChC,+BAA+B;EAC/B,8BAA8B;EAC9B,YAAY;EACZ,QAAQ;EACR,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,+BAA+B;EAC/B,iCAAiC;AACnC;AACA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,SAAS;EACT,6CAA6C;EAC7C,gBAAgB;EAChB,6BAA6B;EAC7B,UAAU;AACZ;AACA;;EAEE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA,qBAAqB;AACrB;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;;;;;;;;EAQE,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,0BAA0B;AAC5B;AACA,qBAAqB;AACrB;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA,iBAAiB;AACjB;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,cAAc;AAChB;AACA,kBAAkB;AAClB;EACE,eAAe;AACjB;AACA,iBAAiB;AACjB;EACE,6BAA6B;EAC7B,yCAAyC;EACzC,8DAA8D;EAC9D,gCAAgC;EAChC,2CAA2C;AAC7C;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;EAEE,gBAAgB;EAChB,wCAAwC;EACxC,iCAAiC;EACjC,yCAAyC;AAC3C;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;;;;EAIE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;;;;;;;;GAQG;AACH;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB;AACA,KAAK;AACL;;EAEE,eAAe;AACjB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;;EAEd;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,UAAU;IACV,eAAe;EACjB;EACA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,uCAAuC;IACvC,eAAe;IACf;MACE,aAAa;IACf;EACF;EACA;IACE,oCAAoC;EACtC;EACA;IACE,aAAa;IACb,aAAa;EACf;EACA;IACE,YAAY;IACZ;MACE,qBAAqB;IACvB;IACA;MACE,aAAa;IACf;EACF;AACF;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,yDAAkD;EAClD,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;AACF","sourcesContent":["/* login */\n.login-hero {\n  background-image: url(../images/login-image.jfif);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n}\n.login-hero .title-line {\n  background-color: rgba(0, 0, 0, 0.75);\n  color: #fff;\n  padding: 20%;\n  height: 70vh;\n  width: 100%;\n}\n.login-hero .title-line .logo {\n  font-size: 28px;\n  font-weight: 600;\n  text-align: left;\n  margin-bottom: 30%;\n}\n.login-hero .title-line p {\n  font-size: 28px;\n  font-weight: 600;\n}\n.login-hero .title-line p .pink {\n  color: #ff55a7;\n}\n.login-hero .title-line p .yellow {\n  color: #ffc960;\n}\n.login-hero .title-line p .cyan {\n  color: #27d4ab;\n}\n.login-form {\n  padding: 0% 15%;\n  font-size: 14px;\n  font-family: \"Poppins\", sans-serif;\n}\n.login-form input {\n  font-size: 14px;\n}\n.login-form h1 {\n  font-size: 24px;\n}\n.login-form a {\n  color: #000;\n  font-size: 12px;\n}\n.login-form a:hover {\n  color: #0c3b83;\n}\n.login-form .login-btn {\n  font-size: 16px;\n  background: #000639;\n  padding: 10px 0px;\n  font-family: \"Poppins\", sans-serif !important;\n}\n.login-form .login-btn:hover {\n  font-size: 16px;\n  background: #000426;\n}\n.copy-right {\n  font-size: 12px;\n  color: #757575;\n  position: absolute;\n  bottom: 10px;\n  text-align: center;\n}\n.login-social .select-upload .bi::before,\n[class*=\" bi-\"]::before,\n[class^=\"bi-\"]::before {\n  font-size: 15px;\n}\n/* sing-form */\n.sing-form a {\n  text-decoration: none;\n  color: #000;\n  font-size: 16px;\n}\n.sing-form .icon {\n  width: 26px;\n  height: 26px;\n}\n/* copy */\n.copy-right {\n  font-size: 12px;\n  color: #757575;\n  position: absolute;\n  bottom: 10px;\n  text-align: center;\n}\n/* photo upload */\n.org-events-photo-upload h5 {\n  font-size: 16px;\n}\n.org-events-photo-upload .file-area {\n  width: 100%;\n  position: relative;\n  color: #cacdd5;\n\n  input[type=\"file\"] {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    opacity: 0;\n    cursor: pointer;\n  }\n  .org-upload-event-photo {\n    width: 100%;\n    padding: 20%;\n    background: #f4f6f8;\n    border: 1px dashed #cacdd5;\n    text-align: center;\n    transition: background 0.3s ease-in-out;\n    font-size: 12px;\n    .success {\n      display: none;\n    }\n  }\n  &:hover .org-upload-event-photo {\n    background: rgba(255, 255, 255, 0.1);\n  }\n  input[type=\"file\"]:focus + .org-upload-event-photo {\n    outline: none;\n    outline: none;\n  }\n  input[type=\"file\"]:valid + .org-upload-event-photo {\n    padding: 2px;\n    .success {\n      display: inline-block;\n    }\n    .default {\n      display: none;\n    }\n  }\n}\n.org-events-photo-upload .file-area .message {\n  color: #000;\n}\n.org-events-photo-upload\n  .modal-dialog\n  .modal-content\n  .modal-footer\n  .btn-upload {\n  background: #000639;\n  color: #fff;\n}\n.org-events-photo-upload\n  .modal-dialog\n  .modal-content\n  .modal-footer\n  .btn-upload:hover {\n  color: #fff;\n  background: #27d4ab;\n}\n.org-events-photo-upload\n  .modal-dialog\n  .modal-content\n  .modal-footer\n  .btn-cancel {\n  color: #000639;\n  border: 1px solid #000639;\n  background: #fff;\n}\n.org-events-photo-upload\n  .modal-dialog\n  .modal-content\n  .modal-footer\n  .btn-cancel:hover {\n  background: #000639;\n  color: #fff;\n}\n.ticket-detail h1 {\n  color: #454f5b;\n  font-size: 18px;\n  font-weight: 600;\n}\n.ticket-detail p {\n  color: #454f5b;\n  font-size: 14px;\n  font-weight: 400;\n}\n.ticket-detail a {\n  color: #454f5b;\n  font-size: 14px;\n  font-weight: 400;\n}\n.readmore {\n  color: #454f5b;\n  font-size: 14px !important;\n  font-weight: 400;\n}\n/* ticket color yellow*/\n.ticket-box-yellow {\n  background: rgba(253, 230, 183, 0.8);\n  border: 2px dashed #ffc960;\n  padding: 20px 50px;\n  position: relative;\n  width: 100%;\n  height: 150px;\n}\n.ticket-box-yellow::before,\n.ticket-box-yellow::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  height: 30px;\n  width: 60px;\n  /* z-index: 1; */\n}\n.ticket-box-yellow::before {\n  border-radius: 150px 150px 0 0;\n  background: #fff;\n  border-right: 2px dashed #ffc960;\n  border-left: 2px dashed #ffc960;\n  border-top: 2px dashed #ffc960;\n  left: -17px;\n  top: 40%;\n  rotate: 90deg;\n}\n.ticket-box-yellow::after {\n  border-radius: 150px 150px 0 0;\n  background: #fff;\n  border-right: 2px dashed #ffc960;\n  border-left: 2px dashed #ffc960;\n  border-top: 2px dashed #ffc960;\n  right: -17px;\n  top: 40%;\n  rotate: -90deg;\n}\n.ticket-info-yellow {\n  background: #fff;\n  border-right: 2px dashed #ffc960;\n  border-left: 2px dashed #ffc960;\n  border-bottom: 2px dashed #ffc960;\n}\n/* ticket color green*/\n.ticket-box-green {\n  background: #bef2e6;\n  border: 2px dashed #27d4ab;\n  padding: 20px 50px;\n  position: relative;\n  width: 100%;\n  height: 150px;\n}\n.ticket-box-green::before,\n.ticket-box-green::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  height: 30px;\n  width: 60px;\n  /* z-index: 1; */\n}\n.ticket-box-green::before {\n  border-radius: 150px 150px 0 0;\n  background: #fff;\n  border-right: 2px dashed #27d4ab;\n  border-left: 2px dashed #27d4ab;\n  border-top: 2px dashed #27d4ab;\n  left: -17px;\n  top: 40%;\n  rotate: 90deg;\n}\n.ticket-box-green::after {\n  border-radius: 150px 150px 0 0;\n  background: #fff;\n  border-right: 2px dashed #27d4ab;\n  border-left: 2px dashed #27d4ab;\n  border-top: 2px dashed #27d4ab;\n  right: -17px;\n  top: 40%;\n  rotate: -90deg;\n}\n.ticket-info-green {\n  background: #fff;\n  border-right: 2px dashed #27d4ab;\n  border-left: 2px dashed #27d4ab;\n  border-bottom: 2px dashed #27d4ab;\n}\n/* View Breakup */\n.view-Breakup-box {\n  background: #454f5b;\n  padding: 5px;\n  font-size: 12px;\n  position: relative;\n}\n.view-Breakup-box-arrow {\n  position: absolute;\n  top: -10px;\n  right: 10px;\n  color: #454f5b;\n}\n.view-Breakup-box .dropdown-item {\n  color: #fff;\n}\n.view-Breakup-box .dropdown-divider {\n  height: 0;\n  margin: var(--bs-dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid #637381;\n  opacity: 1;\n}\n.view-Breakup-box .dropdown-item:focus,\n.dropdown-item:hover {\n  color: none;\n  background: none;\n}\n.org-events-photo-upload a {\n  font-size: 12px;\n}\n.org-events-photo-upload .form-select {\n  font-size: 14px;\n}\n.view-Breakup-box h1 {\n  font-size: 14px;\n  color: #fff;\n}\n/* Participant Form */\n.participant-form .card {\n  font-size: 14px;\n}\n.participant-form .accordion .accordion-item .accordion-header h1 {\n  font-size: 16px;\n  font-weight: 500;\n}\n.participant-form\n  .modal\n  .modal-dialog\n  .modal-content\n  .modal-header\n  .modal-title,\n.participant-form .modal .modal-dialog .modal-content .modal-body h1,\nlabel {\n  font-size: 14px !important;\n}\n.skip {\n  color: #637381;\n  font-size: 14px !important;\n}\n/* Discount Coupons */\n.org-events-photo-upload .discount-Coupons .offer {\n  padding: 10px;\n  width: 100%;\n}\n.org-events-photo-upload .discount-Coupons .offer h1 {\n  font-size: 32px;\n  font-weight: 700;\n}\n.org-events-photo-upload .discount-Coupons .offer h1 span {\n  font-size: 20px;\n  font-weight: 400;\n}\n.org-events-photo-upload .discount-Coupons {\n  border: #eba416 dashed 2px;\n  border-radius: 8px;\n  background: #ffc960;\n  margin: 0 20%;\n}\n.org-events-photo-upload .discount-Coupons .name {\n  background: rgba(255, 255, 255, 0.5);\n  padding: 10px 30px;\n  align-items: center;\n  display: flex;\n  border-right: #000 dashed 2px;\n}\n.org-events-photo-upload .discount-Coupons .name .dis {\n  color: #ffbd3d;\n  font-size: 24px;\n  font-weight: 700;\n  writing-mode: vertical-rl;\n  position: absolute;\n  transform: rotate(-180deg);\n}\n.org-events-photo-upload .discount-Coupons .name .cou {\n  color: #fff;\n  font-size: 40px;\n  font-weight: 700;\n  writing-mode: vertical-rl;\n  margin-left: 30px;\n  transform: rotate(-180deg);\n}\n.org-events-photo-upload .discount-Coupons .discount-Name {\n  font-size: 18px;\n  font-weight: 600;\n}\n.org-events-photo-upload .discount-Coupons .date-time {\n  font-size: 14px;\n}\n.org-events-photo-upload .discount-Coupons .no {\n  font-size: 18px;\n  font-weight: 500;\n}\n.org-events-photo-upload .discount-Coupons a {\n  font-size: 14px;\n  color: #000;\n}\n.discount-Coupons-box {\n  position: relative;\n}\n/* coupan color */\n.org-events-photo-upload .discount-Coupons-green {\n  border: #059170 dashed 2px;\n  background: #27d4ab;\n}\n.org-events-photo-upload .discount-Coupons-green .name {\n  background: rgba(255, 255, 255, 0.5);\n}\n.org-events-photo-upload .discount-Coupons .name .dis-green {\n  color: #08b38b;\n}\n/* Event Setting */\n.event-setting .info-gst {\n  font-size: 14px;\n}\n/* User Profile */\n.user-profile .nav-underline {\n  --bs-nav-underline-gap: 10rem;\n  --bs-nav-underline-border-width: 0.125rem;\n  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);\n  gap: var(--bs-nav-underline-gap);\n  border-bottom: #cacdd5 solid 1px !important;\n}\n.user-profile .nav-underline .nav-item {\n  font-size: 14px;\n}\n.user-profile .icon {\n  padding: 6px 9px;\n  background: #86ffe2;\n  border-radius: 50%;\n}\n.user-profile .nav-link.active,\n.user-profile .nav-link:hover {\n  font-weight: 500;\n  color: var(--Primary-Color-brand-5C6ACA);\n  border-bottom-color: currentcolor;\n  stroke: var(--Primary-Color-brand-5C6ACA);\n}\n.user-profile .nav-link {\n  color: var(--gray-darklight);\n  stroke: var(--gray-darklight);\n}\n.user-profile,\n.user-profile .bashboard-table th,\n.user-profile .btn,\n.user-profile .bashboard-table td {\n  font-size: 12px;\n}\n.user-profile h1 {\n  font-size: 16px;\n}\n.user-profile .tab-content .table-responsive .table tbody .text-success-btn {\n  color: var(--success);\n}\n/* .user-profile svg {\n  width: 25px;\n  height: 25px;\n  stroke: var(--gray-darklight);\n}\n.user-profile svg:hover {\n  fill: red;\n  stroke: var(--Primary-Color-brand-5C6ACA);;\n} */\n.user-profile .send-notification-box {\n  background: #f4f6f8;\n  border: #dfe4e8 1px solid;\n  border-radius: 4px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 50px;\n  height: 44px;\n}\n\n.user-profile .send-notification-box img {\n  width: 25px;\n  height: 25px;\n}\n\n.user-profile .form-switch.form-check-reverse .form-check-input {\n  width: 4em;\n  height: 2em;\n}\n.user-profile .form-switch-text {\n  font-size: 14px;\n}\n.user-profile .my-profile-pic {\n  background: #5c6aca;\n  padding: 10px;\n  font-size: 25px;\n  font-weight: 600;\n  color: #fff;\n  border-radius: 50%;\n  width: 60px;\n  height: 60px;\n  margin: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.user-profile input {\n  font-size: 14px;\n}\n.user-profile .btn {\n  font-size: 14px;\n}\n.user-profile .images {\n  width: 120px !important;\n}\n/*  */\n.organizer-logo,\n.organizer-logo select {\n  font-size: 14px;\n}\n.organizer-logo .file-area {\n  width: 100%;\n  position: relative;\n  color: #cacdd5;\n\n  input[type=\"file\"] {\n    position: absolute;\n    width: 200px;\n    height: 200px;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    opacity: 0;\n    cursor: pointer;\n  }\n  .organizer-logo-photo {\n    width: 200px;\n    height: 200px;\n    background: #f4f6f8;\n    border: 1px solid #cacdd5;\n    text-align: center;\n    border-radius: 8px;\n    transition: background 0.3s ease-in-out;\n    font-size: 12px;\n    .success {\n      display: none;\n    }\n  }\n  &:hover .organizer-logo-photo {\n    background: rgba(255, 255, 255, 0.1);\n  }\n  input[type=\"file\"]:focus + .organizer-logo-photo {\n    outline: none;\n    outline: none;\n  }\n  input[type=\"file\"]:valid + .organizer-logo-photo {\n    padding: 2px;\n    .success {\n      display: inline-block;\n    }\n    .default {\n      display: none;\n    }\n  }\n}\n.organizer-success h1 {\n  font-size: 24px;\n  font-weight: 600;\n}\n.organizer-success-logo {\n  width: 10%;\n  text-align: center;\n}\n.my-profile-banner {\n  position: relative;\n  background: #f9fafb;\n  padding: 20px;\n  background-image: url(../images/my-profile-bg.png);\n  background-repeat: no-repeat;\n}\n.my-profile-banner h1 {\n  font-size: 20px;\n  font-weight: 600;\n}\n.my-profile-banner p {\n  font-size: 14px;\n  font-weight: 500;\n  color: #637381;\n}\n.my-profile-banner .details {\n  font-size: 18px;\n  font-weight: 500;\n  color: #212b35;\n}\n.my-profile-banner .details span {\n  font-size: 20px;\n  font-weight: 600;\n  color: #27d4ab;\n}\n.my-profile-banner-accordion .accordion-button:not(.collapsed) {\n  color: none !important;\n  background-color: #ffffff;\n  box-shadow: none !important;\n}\n@media (max-width: 575.98px) {\n  .user-profile .btn {\n    font-size: 10px;\n  }\n  .user-profile .container {\n    display: none;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .user-profile .btn {\n    font-size: 10px;\n  }\n  .user-profile .container {\n    display: none;\n  }\n}\n@media (max-width: 991.98px) {\n  .user-profile .btn {\n    font-size: 10px;\n  }\n  .user-profile .container {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
